/* PH — land- en regiokiezer rechtsboven (29 okt 2026). Zie sections/ph-market-choice.liquid. */
(() => {
  const root = document.getElementById('ph-market');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  const current = root.dataset.current;
  const tpl = root.querySelector('#ph-mk-chip-tpl');
  const pop = root.querySelector('.ph-mk-pop');
  const panel = root.querySelector('.ph-mk-panel');
  const backdrop = root.querySelector('.ph-mk-backdrop');
  const form = root.querySelector('form');
  const codeInput = form && form.querySelector('input[name="country_code"]');
  const rowsBox = panel.querySelector('[data-ph-mk-rows]');
  const search = panel.querySelector('.ph-mk-search__input');
  const none = panel.querySelector('.ph-mk-none');
  const sugGroup = panel.querySelector('[data-ph-mk-suggested]');
  const sugSlot = panel.querySelector('[data-ph-mk-suggested-slot]');
  const KEY = 'ph_mk_v2';
  const store = {
    get(k) { try { return sessionStorage.getItem(KEY + k); } catch (_) { return null; } },
    set(k, v) { try { sessionStorage.setItem(KEY + k, v); } catch (_) {} }
  };
  const isMobile = () => window.matchMedia('(max-width: 767px)').matches;
  const MARKS = new RegExp('[' + String.fromCharCode(0x300) + '-' + String.fromCharCode(0x36f) + ']', 'g'); // accenten negeren bij zoeken

  // Landen sorteren op naam in de taal van de pagina
  const lang = document.documentElement.lang || 'nl';
  const rows = Array.from(rowsBox.querySelectorAll('.ph-mk-row'));
  rows.sort((a, b) => a.dataset.name.localeCompare(b.dataset.name, lang)).forEach((r) => rowsBox.appendChild(r));

  // Knop naast de winkelwagen zetten (desktopheader en mobiele header)
  const anchors = [];
  document.querySelectorAll('.x-container-header-icons .header-icon-cart, .x-container-header-mobile-nav .header-icon-cart').forEach((cart) => {
    const a = document.createElement('div');
    a.className = 'ph-mk-anchor';
    a.appendChild(tpl.content.cloneNode(true));
    cart.parentNode.insertBefore(a, cart);
    anchors.push(a);
  });
  if (!anchors.length) return;
  document.body.appendChild(backdrop);
  const host = () => anchors.find((a) => a.offsetParent !== null) || anchors[0];
  const chips = () => anchors.map((a) => a.querySelector('.ph-mk-chip'));

  // Venster onder de knop plaatsen; op mobiel over de volle breedte
  const place = (el) => {
    const a = host();
    if (el.parentNode !== a) a.appendChild(el);
    const chip = a.querySelector('.ph-mk-chip');
    const ar = a.getBoundingClientRect();
    const cr = chip.getBoundingClientRect();
    let rightOff = 0;
    if (isMobile() && el === pop) {
      rightOff = -(window.innerWidth - ar.right - 12);
      el.style.width = (window.innerWidth - 24) + 'px';
    } else {
      el.style.width = '';
    }
    el.style.right = rightOff ? rightOff + 'px' : '';
    el.style.setProperty('--ph-mk-arrow', Math.max(12, ar.right - (cr.left + cr.width / 2) - 6 - rightOff) + 'px');
  };

  // Paneel
  let lastChip = null;
  const filter = () => {
    const norm = (s) => s.normalize('NFD').replace(MARKS, '').toLowerCase();
    const q = norm(search.value.trim());
    let shown = 0;
    rows.forEach((r) => {
      const hit = !q || norm(r.dataset.name).includes(q) || r.dataset.code.toLowerCase() === q;
      r.hidden = !hit;
      if (hit) shown += 1;
    });
    none.hidden = shown > 0;
    sugGroup.hidden = !!q || !sugSlot.firstChild;
  };
  const openPanel = (chip) => {
    hidePop(false);
    lastChip = chip || host().querySelector('.ph-mk-chip');
    if (isMobile()) {
      document.body.appendChild(panel);
      panel.style.right = '';
      backdrop.hidden = false;
      document.documentElement.classList.add('ph-mk-lock');
    } else {
      place(panel);
    }
    panel.hidden = false;
    chips().forEach((c) => c.setAttribute('aria-expanded', 'true'));
    panel.querySelector('.ph-mk-panel__list').scrollTop = 0;
    // Desktop: direct zoeken; mobiel: geen toetsenbord laten openspringen
    requestAnimationFrame(() => (isMobile() ? panel : search).focus({ preventScroll: true }));
  };
  const closePanel = (returnFocus) => {
    if (panel.hidden) return;
    panel.hidden = true;
    backdrop.hidden = true;
    document.documentElement.classList.remove('ph-mk-lock');
    chips().forEach((c) => c.setAttribute('aria-expanded', 'false'));
    search.value = '';
    filter();
    if (returnFocus && lastChip) lastChip.focus();
  };
  const choose = (code) => {
    store.set('_done', '1');
    if (!code || code === current || !form || !codeInput) { closePanel(true); hidePop(false); return; }
    codeInput.value = code;
    form.submit();
  };

  anchors.forEach((a) => {
    a.querySelector('.ph-mk-chip').addEventListener('click', (e) => {
      if (panel.hidden) openPanel(e.currentTarget); else closePanel(true);
    });
  });
  panel.addEventListener('click', (e) => {
    const row = e.target.closest('.ph-mk-row');
    if (row) choose(row.dataset.code);
    if (e.target.closest('[data-ph-mk-close]')) closePanel(true);
  });
  backdrop.addEventListener('click', () => closePanel(true));
  search.addEventListener('input', filter);
  document.addEventListener('click', (e) => {
    if (panel.hidden || isMobile()) return;
    if (panel.contains(e.target) || e.target.closest('.ph-mk-chip')) return;
    closePanel(false);
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    if (!panel.hidden) closePanel(true);
    else if (!pop.hidden) hidePop(true);
  });
  window.addEventListener('resize', () => {
    if (!pop.hidden) place(pop);
    if (!panel.hidden && !isMobile()) place(panel);
  });

  // Landadvies
  function hidePop(remember) {
    if (pop.hidden) return;
    pop.hidden = true;
    if (remember) store.set('_done', '1');
  }
  const fill = (tplText, name) => (tplText || '').split('[country]').join(name);
  const suggest = (code) => {
    const row = rows.find((r) => r.dataset.code === code);
    if (!row || code === current) return;
    // Voorgesteld land bovenaan in het paneel
    const clone = row.cloneNode(true);
    clone.classList.remove('is-current');
    clone.removeAttribute('aria-current');
    sugSlot.appendChild(clone);
    sugGroup.hidden = false;
    if (store.get('_done')) return;
    const name = row.dataset.name;
    pop.querySelector('.ph-mk-pop__title').textContent = fill(root.dataset.tSuggestTitle, name);
    pop.querySelector('[data-ph-mk-go]').textContent = fill(root.dataset.tSuggestGo, name);
    pop.querySelectorAll('[data-ph-mk-stay]').forEach((b) => {
      if (!b.classList.contains('ph-mk-x')) b.textContent = fill(root.dataset.tSuggestStay, root.dataset.currentName);
    });
    pop.querySelector('[data-ph-mk-go]').onclick = () => choose(code);
    pop.querySelectorAll('[data-ph-mk-stay]').forEach((b) => { b.onclick = () => hidePop(true); });
    place(pop);
    pop.hidden = false;
    store.set('_done', '1'); // één keer per sessie
  };

  if (window.Shopify && window.Shopify.designMode) return;
  const known = store.get('_geo');
  if (known !== null) { if (known) suggest(known); return; }
  const base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const params = new URLSearchParams({ 'country[enabled]': 'true', 'country[exclude]': current, 'language[enabled]': 'false' });
  fetch(base + 'browsing_context_suggestions.json?' + params, { credentials: 'same-origin' })
    .then((r) => { if (!r.ok) throw new Error('unavailable'); return r.json(); })
    .then((data) => {
      const s = data && data.suggestions && data.suggestions.find((i) => i.parts && i.parts.country);
      const code = s ? s.parts.country.handle : '';
      store.set('_geo', code && code !== current ? code : '');
      if (code && code !== current) suggest(code);
    })
    .catch(() => {});
})();
